import './Layout.module.less'

import { useEffect, useState } from 'react'
import { Layout, Menu } from 'antd'
import Head from 'next/head'
import Router from 'next/router'
import dynamic from 'next/dynamic'
import cn from 'classnames'

import analytics from '../lib/analytics'
import LogoWhite from '../assets/LogoWhite.svg'
import TimetableIcon from '../assets/TimetableIcon.svg'
import ReportsIcon from '../assets/ReportsIcon.svg'
import MenuIcon from '../assets/MenuIcon.svg'
import ClearBlack from '../assets/ClearBlack.svg'
import CaretLeftSvg from '../assets/CaretLeft.svg'
import TeachIcon from '../assets/Teach.svg'

const { Header, Footer, Content } = Layout

const LazyNavMenu = dynamic(() => import('./NavMenu'), { ssr: false })
const TEACH_SCHOOLS = ','.concat(
  process.env.NEXT_PUBLIC_TEACH_SCHOOLS || '',
  ',',
)

/* eslint-disable react/destructuring-assignment, react/prop-types */
export default function MainLayout(props) {
  const [masp, setMasp] = useState(
    () =>
      typeof window !== 'undefined' && JSON.parse(localStorage.getItem('masp')),
  )
  const [showMenu, setShowMenu] = useState(false)
  const [showTeach, setShowTeach] = useState(false)

  const toggleMenu = (open) => {
    // set masp menu open to false
    if (masp && masp.menuOpen && !open) {
      setMasp({ isMasp: masp.isMasp, menuOpen: false })
      localStorage.setItem(
        'masp',
        JSON.stringify({ isMasp: masp.isMasp, menuOpen: false }),
      )
    }
    setShowMenu(open)
  }

  useEffect(() => {
    const { user: { su: [su] = [{}] } = {} } = JSON.parse(
      localStorage.getItem('auth') || '{}',
    )
    setShowTeach(
      TEACH_SCHOOLS.includes(`,${su.schoolid},`) || TEACH_SCHOOLS === ',,',
    )

    const maspInfo = JSON.parse(localStorage.getItem('masp'))
    setMasp(maspInfo)
    if (maspInfo) {
      const { isMasp, menuOpen } = maspInfo
      if (isMasp && menuOpen) {
        setShowMenu(menuOpen)
      }
    }
  }, [props.route])

  return (
    <>
      <Head>
        <title>{`${props.title || 'Home'} | LEAD`}</title>
      </Head>
      {props.show ? (
        <Layout
          className={cn({
            'show-menu': showMenu,
            'has-footer': props.footer,
          })}
        >
          {!showMenu && props.header ? (
            <Header className="header-main">
              <div className="header-content">
                <span>
                  <div
                    style={{
                      height: '56px',
                      ...(props.logo ? { lineHeight: '20px' } : {}),
                    }}
                  >
                    {props.logo && (
                      <LogoWhite
                        style={{
                          display: 'block',
                          height: '32px',
                          padding: '7px 0 2px',
                        }}
                      />
                    )}
                    {props.back && (
                      <a
                        href={props.back}
                        onClick={(e) => {
                          e.preventDefault()
                          const ua = (navigator.userAgent || '').split(/\W+/)
                          const isWebView =
                            ua.indexOf('Android') > -1 &&
                            ua.indexOf('wv') > ua.indexOf('Android') &&
                            !1

                          if (window.history.length >= 2 || isWebView) {
                            Router.back()
                          } else Router.replace('/classes')
                        }}
                        style={{
                          color: 'white',
                          padding: '8px 6px 8px 0',
                          marginRight: '8px',
                        }}
                      >
                        {props.back.match(/\?close$/) ? (
                          <ClearBlack
                            fill="white"
                            style={{ transform: 'scale(1.5)' }}
                          />
                        ) : (
                          <CaretLeftSvg
                            style={{
                              transform: 'scale(1.2)',
                              verticalAlign: 'middle',
                            }}
                          />
                        )}
                      </a>
                    )}
                    <span>{props.route === '/404' ? '' : props.title}</span>
                  </div>
                </span>
              </div>
            </Header>
          ) : (
            <Header className="header-main">
              <div className="header-content">
                <div style={{ height: '56px' }}>
                  {showMenu ? 'Menu' : props.title}
                </div>
              </div>
            </Header>
          )}
          <Content id="content-main" className="content-main">
            <LazyNavMenu
              visible={showMenu}
              pageTitle={props.title || 'Not Found'}
              onClose={() => toggleMenu(false)}
            />
            {props.children}
          </Content>
          {props.footer && (
            <Footer className="footer-nav">
              <Menu
                mode="horizontal"
                selectedKeys={
                  showMenu || props.route === '/classes/paused'
                    ? 'menu'
                    : props.route.match(/\/\w+/)
                }
                onClick={({ key }) => {
                  const action =
                    key === '/doubts' ? 'doubts' : key.replace('/', 'my_')
                  analytics.track(`${action}_clicked`, {
                    from_previous_screen: props.title || 'Not Found',
                    menu_visible: showMenu,
                  })

                  if (key === 'menu') toggleMenu(!showMenu)
                  else {
                    if (showMenu) toggleMenu(false)
                    Router.push(key)
                  }
                }}
              >
                <Menu.Item key="/classes" icon={<TimetableIcon />}>
                  <div>Timetable</div>
                </Menu.Item>

                {showTeach && !masp?.isMasp && (
                  <Menu.Item key="/teach" icon={<TeachIcon />}>
                    <div>Teach</div>
                  </Menu.Item>
                )}

                <Menu.Item key="/reports" icon={<ReportsIcon />}>
                  <div>Student Reports</div>
                </Menu.Item>

                <Menu.Item key="menu" icon={<MenuIcon />}>
                  <div>Menu</div>
                </Menu.Item>
              </Menu>
            </Footer>
          )}
        </Layout>
      ) : (
        <Content className="content-open">{props.children}</Content>
      )}
    </>
  )
}
